import React, { useState, useContext } from 'react';
import Context from "../context/context";
import classnames from 'classnames';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Keyboard, Scrollbar, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';

const Checkboxes = props => {
  const {activeFilters, setActiveFilters, filterNav, setFilterNav, setNavStatus} = useContext(Context);
  const {data, active, multi, handleClose, clearAllFilters, widget, single, viewResults} = props;
  const elements = data.elements;
  let checked = [];


  data.elements.forEach(element => {
    if (activeFilters[data.name].value.indexOf(element.value) > -1){
      checked.push(true)
    } else {
      checked.push(false);
    }
  });

  const handleChange = (position, val, title) => {
    const updatedCheckedState = checked.map((item, index) =>
      index === position ? !item : item
    );
    checked = updatedCheckedState;
    const filter = {...activeFilters[data.name]};
    if (filter.value.indexOf(val) > -1) {
      filter.value.splice(filter.value.indexOf(val), 1);
      filter.selectedTitles.splice(filter.selectedTitles.indexOf(title), 1);
    } else {
      filter.value.push(val);
      filter.selectedTitles.push(title);
    }
    setActiveFilters({...activeFilters,
      [data.name]: filter
    });

  }

  const clearTheseFilters = () => {
    const a = {...activeFilters};
    const activeFilter = a[data.name];
    activeFilter.value = [];
    activeFilter.selectedTitles = [];

    setActiveFilters(a);
  }

  return (
    <div className="swiper-outer">

    <Swiper
      slidesPerView={'auto'}
      spaceBetween={0}
      slidesPerGroup={4}
      grabCursor={true}
      direction={'vertical'}
      watchOverflow={true}
      navigation={{
          nextEl: '.swiper-next' + data.name,
          prevEl: '.swiper-prev' + data.name,
      }}
      freeMode={true}
      preventClicks={false}
      modules={[Keyboard, Scrollbar, Navigation, Pagination]}
      className="mySwiper"
    >


      <div className="form-element-section-items">
      {elements.map((element, i) => {
        return (
          <SwiperSlide>
          <div className="form-element form-element-checkbox" key={data.name + '_' + i}>
            <input
              type="checkbox"
              id={data.name + '_' + i}
              name={data.name}
              value={element.value}
              checked={checked[i]}
              onChange={(e) => handleChange(i, e.target.value, element.title)}
            />
            <label htmlFor={data.name + '_' + i}>{element.title}</label>
          </div>
          </SwiperSlide>
        )
      }

      )}
      </div>


    </Swiper>
    <div class="swiper-filter-pagination">
      <button className={"swiper-prev" + data.name} >
        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="51" viewBox="0 0 50 51" fill="none">
          <rect y="50.082" width="50" height="50" transform="rotate(-90 0 50.082)" fill="white"/>
          <path d="M13.2149 31.6329L25 19.8477L36.7851 31.6329" stroke="#E54439" stroke-width="4.58333"/>
        </svg>
      </button>
      <button className={"swiper-next" + data.name}  >
        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="51" viewBox="0 0 50 51" fill="none">
          <rect width="50" height="50" transform="matrix(-4.37114e-08 1 1 4.37114e-08 0 0.917969)" fill="white"/>
          <path d="M13.2149 19.3671L25 31.1523L36.7851 19.3671" stroke="#E54439" stroke-width="4.58333"/>
        </svg>
      </button>
    </div>
    <div className="buttons-bottom">
    <button className="button button-black view-results" onClick={() => viewResults()}>
      View results
    </button>
    <button className="clear-all-filters button button-black-border" onClick={clearTheseFilters}>
      Reset these filters

    </button>
    </div>

    </div>
  
  )
}

export default Checkboxes;
